export const isProductHub = category => category?.additional_items?.custom_taxonomy_configuration?.meta_data?.product_hub_configs?.is_product_hub ?? false;